import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            padding: '2px 4px',
            display: 'flex',
            alignItems: 'center',
        },
        input: {
            marginLeft: theme.spacing(1),
            flex: 1,
        },
        iconButton: {
            padding: 10,
        }
    }),
);

type SearchFieldProps = {
    searchQuery?: string
    setSearchQuery: (query) => void
    executeSearch: () => void
    caption?: string
};


export const SearchField: React.FC<SearchFieldProps> = ({caption, searchQuery, setSearchQuery, executeSearch}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <Paper component="form" className={classes.root} onSubmit={(evt) => {
            evt.preventDefault();
            executeSearch();
        }}>
            <InputBase
                value={searchQuery}
                onChange={(evt) => setSearchQuery(evt.target.value)}
                id="query"
                name={"query"}
                fullWidth={true}
                className={classes.input}
                placeholder={caption ? caption : t("form.search.caption")}
                inputProps={{'aria-label': 'query'}}
            />
            <IconButton type="submit" className={classes.iconButton} aria-label="search-form">
                <SearchIcon/>
            </IconButton>

        </Paper>
    );
};

export default SearchField;